/* eslint-disable no-console */
import { useEffect, useState } from 'react'
import { Box, Collapse, IconButton, Typography } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { motion } from 'motion/react'
import { useSnackbar } from 'notistack'
import { arrowRotate } from '../../utils/animation'
import SvgIconSize from '../../components/Cards/helpers/SvgIconSize'
import { ReactComponent as CopyIcon } from '../../images/Copy.svg'
import HoverTooltip from '../../components/PageHelpers/HoverTooltip'
import UseTranslation from '../../hooks/UseTranslation'

const RolesListData = ({ rolesStore, condition, categoryLabel }) => {
  const [rolesList, setRolesList] = useState([])
  const [isRequestHistoryOpen, setIsRequestHistoryOpen] = useState(true)
  const { t } = UseTranslation()
  const { enqueueSnackbar } = useSnackbar()

  const handleCopyToClipboard = (textToCopy, successMessage) => {
    navigator?.clipboard?.writeText(textToCopy)
    enqueueSnackbar(`${t?.[successMessage]}`, { variant: 'success' })
  }
  useEffect(() => {
    setRolesList(rolesStore?.[condition] || []);
  }, [rolesStore, condition]);

  const toggleRequestHistory = () => {
    setIsRequestHistoryOpen((prevState) => !prevState)
  }

  return (
    <Box>
      {rolesList?.length > 0 ? (
        <Box>
      <Box sx={styles.headerContainer}>
            <Box sx={styles.headerTextContainer}
            onClick={() => handleCopyToClipboard(categoryLabel, 'Module name has been copied to your clipboard')}
            >
        <HoverTooltip title={t?.['Copy Module']}>
        <Typography variant='heading3' sx={styles.headerText}>{categoryLabel}</Typography>
          </HoverTooltip>
          <Box
      component="span"
      sx={styles.copyIcon}
    >
     <SvgIconSize
      icon={<CopyIcon />}
      size={20}
      color="#29cc8b"
     />
    </Box>
        </Box>
        <IconButton onClick={toggleRequestHistory}>
          {isRequestHistoryOpen ? (
            <ExpandLessIcon
              component={motion.svg}
              variants={arrowRotate}
              initial="initial"
              animate="animate"
              transition="transition"
            />
          ) : (
            <ExpandMoreIcon
              component={motion.svg}
              variants={arrowRotate}
              initial="initial"
              animate="animate"
              transition="transition"
            />
          )}
        </IconButton>
      </Box>

        <Collapse in={isRequestHistoryOpen}>
  <Box sx={styles.rolesListContainer}>
    {rolesList.map((singleRole) => (
      <Box key={singleRole.id} sx={styles.roleItem}
        onClick={() => handleCopyToClipboard(singleRole.display_name, 'Role Name has been copied to Clipboard')}
        >
    <HoverTooltip title={t?.['Copy Role']}>
    <Typography variant="body1" sx={styles.roleName}>
      {singleRole.display_name}
    </Typography>
    </HoverTooltip>
    <Box
      component="span"
      sx={styles.copyIcon}
    >
     <SvgIconSize
      icon={<CopyIcon />}
      size={20}
      color="#29cc8b"
     />
    </Box>
  </Box>
    ))}
          </Box>
          </Collapse>
          </Box>
      )
        : null}
    </Box>
  )
}

const styles = {

  headerContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #d1d1d1',
    margin: '10px 0px',
  },
  headerTextContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
  },
  headerText: {
    fontWeight: 'bold',
    marginBottom: '10px',
  },
  rolesListContainer: {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
    gap: '10px',
    marginTop: '10px',
  },
  roleItem: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    gap: '10px',
  },

  roleName: {
    fontWeight: 500,
    width: 'fit-content',
    marginBottom: '5px',
  },

  copyIcon: {
    marginLeft: '10px',
    fontSize: '18px',
    color: '#29cc8b',
    '&:hover': {
      opacity: 0.8,
    },
  },

}

export default RolesListData
